module.exports = __webpack_public_path__ + "static/media/cookedmorsel.ecc103c2.webp";